export default "__VITE_ASSET__CzNZnf5Y__"